module.exports = "/images/london-4.jpg";